// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

import "mdn-polyfills/Node.prototype.firstElementChild";

import parseXML from "xml-parse-from-string";

import { library, dom } from "@fortawesome/fontawesome-svg-core";

import { faAngleDown as fasFaAngleDown } from "@fortawesome/pro-solid-svg-icons/faAngleDown";
import { faAngleLeft as fasFaAngleLeft } from "@fortawesome/pro-solid-svg-icons/faAngleLeft";
import { faAngleRight as fasFaAngleRight } from "@fortawesome/pro-solid-svg-icons/faAngleRight";
import { faAngleUp as fasFaAngleUp } from "@fortawesome/pro-solid-svg-icons/faAngleUp";
import { faArrowRight as fasFaArrowRight } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { faBars as fasFaBars } from "@fortawesome/pro-solid-svg-icons/faBars";
import { faCaretDown as fasFaCaretDown } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { faCheck as fasFaCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faCircle as fasFaCircle } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { faClock as fasFaClock } from "@fortawesome/pro-solid-svg-icons/faClock";
import { faComment as fasFaComment } from "@fortawesome/pro-solid-svg-icons/faComment";
import { faFolder as fasFaFolder } from "@fortawesome/pro-solid-svg-icons/faFolder";
import { faPhone as fasFaPhone } from "@fortawesome/pro-solid-svg-icons/faPhone";
import { faQuestionCircle as fasFaQuestionCircle } from "@fortawesome/pro-solid-svg-icons/faQuestionCircle";
import { faSearch as fasFaSearch } from "@fortawesome/pro-solid-svg-icons/faSearch";
import { faShareSquare as fasFaShareSquare } from "@fortawesome/pro-solid-svg-icons/faShareSquare";
import { faTag as fasFaTag } from "@fortawesome/pro-solid-svg-icons/faTag";
import { faTimes as fasFaTimes } from "@fortawesome/pro-solid-svg-icons/faTimes";
import { faUserCircle as fasFaUserCircle } from "@fortawesome/pro-solid-svg-icons/faUserCircle";

import svgAward from "../../media/fac-award.svg";
import svgCheers from "../../media/fac-cheers.svg";
import svgCrane from "../../media/fac-crane.svg";
import svgFloorplan from "../../media/fac-floorplan.svg";
import svgHeartShake from "../../media/fac-heart-shake.svg";
import svgKeys from "../../media/fac-keys.svg";
import svgVideo from "../../media/fac-video.svg";
import svgWheelbarrowMan from "../../media/fac-wheelbarrow-man.svg";

/**
 * Add solid icons
 */
library.add(fasFaAngleDown, fasFaAngleLeft, fasFaAngleRight, fasFaAngleUp, fasFaCheck, fasFaClock, fasFaComment, fasFaFolder, fasFaQuestionCircle, fasFaSearch, fasFaShareSquare, fasFaTag, fasFaUserCircle, fasFaAngleDown, fasFaBars, fasFaCaretDown, fasFaCircle, fasFaPhone, fasFaSearch, fasFaTimes, fasFaArrowRight);


/**
 * Add custom icons
 */
library.add({
    "award": {
        iconName: "award",
        prefix: "fac",
        icon: [
            svgAward.attributes.viewBox.split(" ")[2],
            svgAward.attributes.viewBox.split(" ")[3],
            [],
            "e000",
            parseXML(svgAward.content).firstElementChild.getAttribute("d"),
        ]
    },
    "cheers": {
        iconName: "cheers",
        prefix: "fac",
        icon: [
            svgCheers.attributes.viewBox.split(" ")[2],
            svgCheers.attributes.viewBox.split(" ")[3],
            [],
            "e001",
            parseXML(svgCheers.content).firstElementChild.getAttribute("d"),
        ]
    },
    "crane": {
        iconName: "crane",
        prefix: "fac",
        icon: [
            svgCrane.attributes.viewBox.split(" ")[2],
            svgCrane.attributes.viewBox.split(" ")[3],
            [],
            "e002",
            parseXML(svgCrane.content).firstElementChild.getAttribute("d"),
        ]
    },
    "floorplan": {
        iconName: "floorplan",
        prefix: "fac",
        icon: [
            svgFloorplan.attributes.viewBox.split(" ")[2],
            svgFloorplan.attributes.viewBox.split(" ")[3],
            [],
            "e003",
            parseXML(svgFloorplan.content).firstElementChild.getAttribute("d"),
        ]
    },
    "heart-shake": {
        iconName: "heart-shake",
        prefix: "fac",
        icon: [
            svgHeartShake.attributes.viewBox.split(" ")[2],
            svgHeartShake.attributes.viewBox.split(" ")[3],
            [],
            "e004",
            parseXML(svgHeartShake.content).firstElementChild.getAttribute("d"),
        ]
    },
    "keys": {
        iconName: "keys",
        prefix: "fac",
        icon: [
            svgKeys.attributes.viewBox.split(" ")[2],
            svgKeys.attributes.viewBox.split(" ")[3],
            [],
            "e005",
            parseXML(svgKeys.content).firstElementChild.getAttribute("d"),
        ]
    },
    "video": {
        iconName: "video",
        prefix: "fac",
        icon: [
            svgVideo.attributes.viewBox.split(" ")[2],
            svgVideo.attributes.viewBox.split(" ")[3],
            [],
            "e006",
            parseXML(svgVideo.content).firstElementChild.getAttribute("d"),
        ]
    },
    "wheelbarrow-man": {
        iconName: "wheelbarrow-man",
        prefix: "fac",
        icon: [
            svgWheelbarrowMan.attributes.viewBox.split(" ")[2],
            svgWheelbarrowMan.attributes.viewBox.split(" ")[3],
            [],
            "e007",
            parseXML(svgWheelbarrowMan.content).firstElementChild.getAttribute("d"),
        ]
    },
});

/**
 * Watch the DOM to insert icons
 */
dom.watch();
